import * as React from "react";
const SvgCycleDisable = (props) => /* @__PURE__ */ React.createElement("svg", { id: "b", xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 53 53", height: "1em", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M25.57,50.8c-11.2,0-24.27-9.33-24.27-24.27,0-14.93,13.07-24.27,24.27-24.27,11.2,0,24.27,9.33,24.27,24.27,0,9.33-5.6,16.8-11.2,20.53M36.77,34l1.87,13.07,13.07,1.87", style: {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: "2.5px"
} }));
export default SvgCycleDisable;
